module.exports = __webpack_public_path__ + "static/img/sec1-slide-img01.f695070.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hanssem/sec1-slide-img01.jpg
// module id = j4Fq
// module chunks = 0